// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lead_requests_table table td[data-v-ef3fdc7a]{text-align:center}.lead_requests_table .v-data-footer__select[data-v-ef3fdc7a]{display:none}.errorMsg[data-v-ef3fdc7a],.infoMsg[data-v-ef3fdc7a]{padding:0 20px}.field[data-v-ef3fdc7a]{margin-right:20px}", ""]);
// Exports
module.exports = exports;
